import React from 'react';
import { Title, TitleWrapper } from './elements';

type LeaderboardTitle = {
  readonly title: string;
  readonly children?: React.ReactNode;
};

export function LeaderboardTitle({
  title,
  children,
}: LeaderboardTitle): React.ReactElement {
  return (
    <TitleWrapper>
      <Title>{title}</Title>
      {children}
    </TitleWrapper>
  );
}
